export function ProgressBar({
  currentStage,
  numberOfStages,
}: {
  currentStage: number;
  numberOfStages: number;
}) {
  const totalSteps = numberOfStages;
  const width = `${(currentStage / totalSteps) * 100}%`;

  return (
    <div className="flex flex-col items-center gap-2 mb-4">
      <p className="text-xs uppercase text-foreground-secondary">
        {currentStage === 1 && "Select your solution"}
        {currentStage === 2 && "Confirm purchase method"}
        {currentStage === 3 && "Log in or sign up"}
      </p>
      <div className="w-[250px] h-[7px] bg-surface-two rounded-full overflow-hidden flex items-center">
        <div
          className="h-full bg-brand-primary rounded-r-full transition-[width] duration-200"
          style={{
            width: width,
          }}
        />
      </div>
      <div className="text-xs text-foreground-secondary">
        Step {currentStage} of {totalSteps}
      </div>
    </div>
  );
}
